const indexItems = [
  { label: '动作片', count: '1,280部', icon: 'ri-sword-line' },
  { label: '喜剧片', count: '956部', icon: 'ri-emotion-laugh-line' },
  { label: '爱情片', count: '843部', icon: 'ri-heart-line' },
  { label: '科幻片', count: '672部', icon: 'ri-rocket-line' },
  { label: '恐怖片', count: '518部', icon: 'ri-ghost-line' },
  { label: '动画片', count: '1,104部', icon: 'ri-movie-line' },
  { label: '纪录片', count: '397部', icon: 'ri-camera-lens-line' },
  { label: '国产剧', count: '2,350部', icon: 'ri-tv-line' },
  { label: '海外剧', count: '1,876部', icon: 'ri-global-line' },
];

export default function IndexSection() {
  return (
    <section id="index" className="w-full py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
            分类索引
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-lg mx-auto">
            按类型快速浏览，找到你最爱的影视品类
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-3 md:gap-4">
          {indexItems.map((item, i) => (
            <a
              key={i}
              href="#cards"
              className="group flex flex-col items-center gap-2 p-4 md:p-5 bg-background-50 border border-background-200/70 rounded-xl hover:border-primary-200 hover:bg-primary-50/30 transition-all duration-200 cursor-pointer text-center"
            >
              <div className="w-10 h-10 rounded-xl bg-primary-100 flex items-center justify-center group-hover:bg-primary-200 transition-colors">
                <i className={`${item.icon} text-lg text-primary-600`}></i>
              </div>
              <span className="text-sm font-medium text-foreground-800 whitespace-nowrap">{item.label}</span>
              <span className="text-xs text-foreground-400">{item.count}</span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}